import React, { CSSProperties, forwardRef, ReactNode } from 'react'
import classNames from 'classnames'

const DropCard = forwardRef<
  HTMLDivElement,
  { additionalClassName: string; children: ReactNode; style?: CSSProperties }
>((props, ref) => {
  return (
    <div
      className={classNames('rounded-md bg-white shadow-md', props.additionalClassName)}
      ref={ref}
      style={props.style}
    >
      {props.children}
    </div>
  )
})

DropCard.displayName = 'DropCard'

export default DropCard
